import Config from '../config/Config.js';
import FcmTokenService from '../firebase/FcmTokenService.js';

class Security {
	static logout() {
		FcmTokenService.eliminarTokenActual()
			.finally(() => Security.cerrarSesionEnServidor())
			.finally(() => {
				Security.limpiarSesionLocal();
				window.location.href = '';
			});
	}

	static cerrarSesionEnServidor() {
		return fetch(Config.get('apiUrlBase') + '/auth/logout', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem("token")
			}
		}).catch(err => console.error('[Security] Error al cerrar la sesión en el servidor:', err));
	}

	static limpiarSesionLocal() {
		["token", "persona", "config", "configBusiness", "userLocale", "eric:history"]
			.forEach(clave => localStorage.removeItem(clave));
	}

	/**
	 * Clave de localStorage acotada al usuario logueado.
	 *
	 * Lo que las grillas persisten (filtros y columnas) se guarda por DISPOSITIVO, pero un
	 * dispositivo lo comparten varios usuarios —una terminal de taller o depósito—: con una
	 * clave fija, el que entra hereda lo que dejó el anterior (VEC-3769).
	 *
	 * El id del usuario las separa. Como cada uno conserva la suya, volver a entrar recupera
	 * lo propio y *** EL LOGOUT NO TIENE QUE BORRAR NADA ***, que es justo lo que pide la card.
	 *
	 * Sin sesión devuelve la clave pelada: no hay a quién atribuirle lo guardado.
	 */
	static claveDeUsuario(base) {
		const persona = JSON.parse(localStorage.getItem("persona"));
		const usuarioId = persona && persona.usuario && persona.usuario.id;
		return usuarioId ? base + ':u' + usuarioId : base;
	}

	/**
	 * *** TEMPORAL — COMPATIBILIDAD DE VEC-3769. BORRAR CUANDO LLEVE TIEMPO EN PRODUCCIÓN. ***
	 *
	 * Hasta VEC-3769 las grillas guardaban bajo una clave sin usuario. Esa entrada NO TIENE
	 * DUEÑO: la escribió el último que filtró en esa máquina y no hay forma de saber quién fue.
	 * Así que se le adjudica al primero que abra la grilla después del despliegue, y se borra.
	 *
	 * Es una decisión tomada a ojos abiertos: ese primero puede heredar los filtros de otro, UNA
	 * última vez. Se acepta porque hoy esa herencia pasa SIEMPRE —es el bug que arregla la card—
	 * y así se conserva lo guardado en vez de que todos arranquen en blanco.
	 *
	 * Al borrarla, borrar también la llamada (los dos hooks vuelven a usar `claveDeUsuario`).
	 */
	static migrarClaveSinUsuario(base) {
		const clave = this.claveDeUsuario(base);
		if (clave === base) return clave; // sin sesión no hay a dónde migrar, y borrar sería perderla

		if (localStorage.getItem(base) !== null && localStorage.getItem(clave) === null) {
			localStorage.setItem(clave, localStorage.getItem(base));
		}
		// Se va aunque no se haya adoptado: ya nadie la lee, y dejarla haría que el próximo
		// usuario de esta máquina heredara lo mismo otra vez.
		localStorage.removeItem(base);

		return clave;
	}

	static hasPermission(permission) {
		return this.hasAllPermissions([permission]);
	}

	static hasAnyPermission(permissions) {
		let hasAnyPermission = false;
		let persona = JSON.parse(localStorage.getItem("persona"));
		if(permissions && persona && persona.usuario && persona.usuario.perfil && persona.usuario.perfil.permisos) {
			let permisos = persona.usuario.perfil.permisos;
			hasAnyPermission = permisos.some(p => permissions.indexOf(p) >= 0);
		}
		return hasAnyPermission;
	}

	static hasAllPermissions(permissions) {
		let hasAllPermissions = false;
		let persona = JSON.parse(localStorage.getItem("persona"));
		if(persona && persona.usuario && persona.usuario.perfil && persona.usuario.perfil.permisos) {
			let permisos = persona.usuario.perfil.permisos;
			hasAllPermissions = permissions.every(p => permisos.indexOf(p) >= 0);
		}
		return hasAllPermissions;
	}

	static isInternal() {
		let persona = JSON.parse(localStorage.getItem("persona"));
		return persona ? persona.is_internal : false;
	}

	// Espeja Configuration::isLocalDevEnvironment() || isTestEnvironment() del backend.
	// El appEnv viaja en el response de los endpoints /auth/*/login (ver AuthController).
	static isLocalDevEnvironment() {
		let persona = JSON.parse(localStorage.getItem("persona"));
		let appEnv = persona && persona.appEnv;
		return appEnv === 'dev' || appEnv === 'test';
	}

	static renderIfHasPermission(permission, jsx) {
		return this.hasPermission(permission) ? jsx : '';
	}

	static renderIfHasAnyPermission(permissions, jsx) {
		return this.hasAnyPermission(permissions) ? jsx : '';
	}

	static renderIfHasAllPermissions(permissions, jsx) {
		return this.hasAllPermissions(permissions) ? jsx : '';
	}
}

export default Security;
